
export type GetTweetById200MediaItemType = typeof GetTweetById200MediaItemType[keyof typeof GetTweetById200MediaItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTweetById200MediaItemType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  GIF: 'GIF',
} as const;
